/**
 * Table data-body range — getDataBodyRangeOrNullObject requires a newer Excel API set;
 * fall back to getDataBodyRange() for broader compatibility.
 * @param {Excel.Table} table
 * @returns {Excel.Range}
 */
export function getTableDataBodyRange(table) {
  if (table && typeof table.getDataBodyRangeOrNullObject === 'function') {
    return table.getDataBodyRangeOrNullObject();
  }
  return table.getDataBodyRange();
}

/**
 * After sync() with rowCount (and isNullObject when applicable) loaded on the data body range.
 * @param {Excel.Range} bodyRange
 */
export function tableDataBodyHasRows(bodyRange) {
  if (!bodyRange) return false;
  if (bodyRange.isNullObject === true) return false;
  return typeof bodyRange.rowCount === 'number' && bodyRange.rowCount > 0;
}
